import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Dish } from 'types';

export const getDishes = async (): Promise<Dish[]> => {
  const { data }: { data: Dish[] } = await axios.get(`/api/dishes`);
  return data as Dish[];
};

type QueryFnType = typeof getDishes;

type UseDishesOptions = {
  config?: QueryConfig<QueryFnType>;
  locationId?: number;
};

export const useDishes = ({ config }: UseDishesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['dishes'],
    queryFn: () => getDishes(),
    ...config,
  });
};

export const useDishesByLocation = ({ locationId, config }: UseDishesOptions) =>
  useDishes({
    config: {
      ...config,
      select: useCallback(
        (dishes: Dish[]) =>
          dishes.filter((dish) => dish.location_id === locationId),
        [locationId]
      ),
    },
  });
